import React, { FC, useState } from 'react';
import { Box, Button, Typography, useTheme } from '@mui/material';
import Helper from '../../shared/helpers/Helper';
import { MoreVert } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface Props {
  text: string | null;
  maxLength?: number;
}

const ReviewText: FC<Props> = ({ text, maxLength }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [showFullText, setShowFullText] = useState(false);

  if (text) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', mt: theme.spacing(2) }}>
        <Typography variant="body1">
          {showFullText ? text : Helper.shortText(text, maxLength ?? 200)}
        </Typography>
        {text.length > 200 && (
          <Box>
            <Button
              variant="outlined"
              size="small"
              startIcon={<MoreVert />}
              onClick={() => setShowFullText(!showFullText)}
              sx={{
                my: theme.spacing(2),
              }}
            >
              {showFullText ? `${t('show_less')}` : `${t('show_more')}`}
            </Button>
          </Box>
        )}
      </Box>
    );
  } else {
    return null;
  }
};

export default ReviewText;
